<template>
    <content-view>
        <a-spin :spinning="spinning" tip="商品数据加载中...">
            <div class="wrap-container-in">
                <div class="mb16">
                    <a-button type="primary" @click="showBatchGoodsPicker">商品选择</a-button>
                </div>
                <a-table
                bordered
                :scroll="{y: 500}"
                :pagination="false"
                :columns="columns"
                :dataSource="selectedRows"
                :rowKey="item => item.id"
                class="wrap-table"
                >
                    <template slot="index" slot-scope="text, record, index">
                        {{index + 1}}
                    </template>
                    <template slot="goodsSize" slot-scope="goodsSize">
                        {{goodsSize || "-"}}
                    </template>
                    <template slot="goodsNum" slot-scope="text, record, index">
                        <a-input-number @change="change($event, record)" v-model="record.goodsNum" placeholder="请输入" />
                        <div v-if="record.showError" class="text-fail">所填值必须为正整数</div>
                    </template>
                    <template slot="addAfterCount" slot-scope="text, record, index">
                        {{record.goodsNum ? record.currentInventory + record.goodsNum : record.currentInventory}}
                    </template>
                    <template slot="action" slot-scope="text, rocerd, index">
                        <a @click="batchAddRemove(rocerd.id)" class="text-primary">删除</a>
                    </template>
                </a-table>
                <div class="text-center mt24">
                    <a-button type="primary" @click="batchAddBoundSave" :loading="batchAddBoundLoading">提交</a-button>
                </div>
            </div>
        </a-spin>
        <goods-batch-picker ref="goodsBatchPicker" :warehouseName="warehouseInfo.name" :goodsList="allGoodsList" :selectedRowKeys="selectedRowKeys" @confirm="batchAddGoodsModalConfirm"></goods-batch-picker>
    </content-view>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
import goodsBatchPicker from "@/components/modules/storage/goods-batch-picker.component";
import index from '../../utils';
        let columns = [
        {
            title: '序号',
            scopedSlots: { customRender: 'index'},
            width: 100
        },
        {
            title: '商品编号',
            dataIndex: 'goodsNo',
            width: 150
        },
        {
            title: '商品名称',
            dataIndex: 'goodsName',
        },
        {
            title: '商品规格',
            dataIndex: 'goodsSpecification',
            width: 100
        },
        {
            title: '所在仓库',
            dataIndex: 'warehouseName',
            width: 150
        },
        {
            title: '当前库存数',
            dataIndex: 'currentInventory',
            width: 100
        },
        {
            title: ' 入库数',
            dataIndex: 'goodsNum',
            scopedSlots: { customRender: 'goodsNum'},
            width: 150
        },
        {
            title: ' 入库后库存数',
            dataIndex: 'addAfterCount',
            scopedSlots: { customRender: 'addAfterCount'},
            width: 100
        },
        {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
            width: 100
        }];
    export default {
        name: 'storageSave',
        components: {
            goodsBatchPicker
        },
        props: {},
        data() {
            return {
                warehouseInfo: {},
                columns,
                batchAddBoundLoading: false,
                selectedRowKeys: [],
                selectedRows: [],
                allGoodsList: [],
                spinning: false
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        watch: {
            shopId() {
                this.getWarehouseInfo();
            }
        },
        methods: {
            /**
             * @change 入库数输入回调
             */
            change(val, record) {
                if (val === null || typeof val === 'undefined') {
                    return false;
                }
                const regExp = /^[1-9]{1,}\d*$/;
                if (!regExp.test(val)) {
                    record.showError = true;
                } else {
                    record.showError = false;
                }
                
            },
            /**
             * @getWarehouseInfo 获取仓库详情
             */
            getWarehouseInfo() {
                let warehouseId = this.$route.params.warehouseId;
                this.$api.newStorage.selfWarehouseInfo({
                    query: {
                        id: warehouseId
                    }
                }).then(res => {
                    this.warehouseInfo = res;
                    this.getCategoryAndGoods();
                });
            },
            /**
             * @batchAddBoundSave 批量添加库存
            */ 
            batchAddBoundSave() {
                let { selectedRows } = this;
                let length = selectedRows.length;
                if (!Boolean(length)) {
                    this.$message.error('请添加商品');
                    return false;
                }
                for(let i = 0;i < length; i++) {
                    const regExp = /^[1-9]{1,}\d*$/;
                    let goodsNum = selectedRows[i].goodsNum;
                    if(!Boolean(goodsNum) || !regExp.test(goodsNum)) {
                        this.$message.error(`请正确填写第${i + 1}项的入库数量`);
                        return false;
                    }
                }
                let infoList = selectedRows.map(item => {
                    return ({
                        goodsId: item.id,
                        goodsNum: item.goodsNum
                    });
                });
                this.batchAddBoundLoading = true;
                this.$api.newStorage.selfBatchGoodsAddNum({
                    body: {
                        infoList,
                        shopId: this.shopId,
                        userId: this.userInfo.id,
                        account: this.userInfo.account,
                        username: this.userInfo.name
                    }
                }).then(res => {
                    this.batchAddBoundLoading = false;
                    this.$message.success('操作成功');
                    setTimeout(() => {
                        this.selectedRowKeys = [];
                        this.selectedRows = [];
                        this.$router.back();
                    }, 300);
                }).catch(err => {
                    this.batchAddBoundLoading = false;
                });
            },
            /**
             * @showBatchGoodsSelected 打开批量选择商品弹窗
             */
            showBatchGoodsPicker() {
                this.$refs.goodsBatchPicker.visible = true;
            },
            /**
             * @batchAddGoodsModalConfirm 批量添加库存弹窗确定
             */
            batchAddGoodsModalConfirm({selectedRowKeys, selectedRows}) {
                this.selectedRowKeys = selectedRowKeys;
                selectedRows.forEach(item => {
                    item.showError = false;
                    item.goodsNum = undefined;
                });
                this.selectedRows = selectedRows;
            },
            /**
             * @getCategoryAndGoods 获取分组及分组下所有商品信息
             */
            getCategoryAndGoods() {
                if (!this.shopId) {
                    return false;
                }
                this.spinning = true;
                this.$api.newStorage.selfCategoryAndGoods({
                    body: {
                        shopId: this.shopId,
                        warehouseId: this.warehouseInfo.id
                    }
                }).then(res => {
                    if (Boolean(res)) {
                        res.forEach(item => {
                            item.vos.forEach($item => {
                                $item.categoryId = item.id;
                                $item.warehouseName = this.warehouseInfo.warehouseName;
                            });
                        });
                        this.allGoodsList = res;
                    }
                    this.spinning = false;
                });
            },
            /**
             * @batchAddRemove 批量增加项删除
             */
            batchAddRemove(id) {
                this.selectedRowKeys = this.selectedRowKeys.filter(item => item !== id);
                this.selectedRows = this.selectedRows.filter(item => item.id !== id);
            }
        },
        beforeCreate() {
            this.userInfo = this.$userInfoTool.getUser();
        },
        created() {},
        mounted() {
            this.getWarehouseInfo();
        }
    };
</script>
<style lang="scss">
    
</style>